<!--
 * @Author: M.D.
 * @Date: 2019-12-23 14:27:59
 * @LastEditors  : M.D.
 * @Description: 常见问题
 * @Remarks:
 -->
<template>
  <div class="q-detail bShadow-5">
    <el-tabs v-model="curTabName" class="ui-tabs ui-custom-s">
      <el-tab-pane name="qaDetail" class="my-msg">
        <span slot="label" class="lb-txt">常见问题</span>
        <div class="dialog-header">
        {{ question.title }}
        </div>
        <div class="dialog-info" v-if="question.date">
        <div class="dialog-date">发布时间：{{ question.date }}</div>
        </div>
        <div class="mp-d-content" v-html="question.content">
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  name: 'qaDetail',
  data () {
    return {
      question: {},
      curTabName: 'qaDetail'
    }
  },
  computed: {

  },
  created () {

  },
  mounted () {

  },
  activated () {
    this.question = this.$route.params
  },
  deactivated () {

  },
  watch: {

  },
  methods: {

  },
  components: {

  }
}
</script>

<style lang="stylus">
.q-detail
  max-width 960px
  box-sizing border-box
  background-color #ffffff
  // padding-left 20px
  // padding-right 20px
  .dialog-header
    padding 20px 40px 0 40px
    font-weight 500
    font-size 25px
    height 100%
  .mp-d-content
    overflow-x scroll
    padding 20px 40px
  .dialog-info
    width 100%
    height 50px
    .dialog-author
      display inline
      font-size 12px
      line-height 50px
      color #999
      margin-right 8px
    .dialog-date
      font-size 12px
      display inline
      line-height 50px
      color #999
</style>
